import axiosClient from "./axiosClient"

const portalsApi = {
  getAll: () => axiosClient.get("/portals/", { authRequired: true }),
  getById: id => axiosClient.get(`/portals/${id}`, { authRequired: true }),
  getArticles: (portalId, page, pageSize) =>
    axiosClient.get(`/portals/${portalId}/articles`, {
      params: { page, page_size: pageSize },
      authRequired: true,
    }),
}

export default portalsApi
